export const ROUTE = {
  customForm: '/custom-form/:id?',
  customFormTemplate: '/custom-form-template/:id?',
  public: '/public/:publicLinkId',
  forbidden: '/forbidden',
  notFound: '/not-found',
};